import React from 'react';
import CardTemplateComponent from '../CardTemplate';
import ImageLightbox from '../../Common/ImageLightbox';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import { gtmSend } from '../../../helpers';

const QuestionCard = ({title, question, images, viewUrl, inFeed, showNSFW, nsfwHandler, match, t, botIndex, url, contentHub}) => {
    //let mainContent = question;

    let relValue = {};
    if(!botIndex){
        relValue = {
            rel: "nofollow"
        };
    }

    let titleHtml = "";
    if(title) {
        if(inFeed) {
            titleHtml = <p className={cx("page-title", "pointer-click")} onClick={() => {gtmSend('dynamic', 'Question Card', 'click-title-click', match.path)}}>
                            <a href={`${contentHub? url : `/${viewUrl}`}`} {...relValue} dangerouslySetInnerHTML={{__html: title}}></a>
                        </p>
        }
        else {
            titleHtml = <h1 className={cx("page-title")} dangerouslySetInnerHTML={{__html: title}}></h1>
        }
    }

    let mainContentHtml = "";
    if(question){
        if(!title && !inFeed) {
            mainContentHtml = <h1 dangerouslySetInnerHTML={{__html: question}}></h1>
        }
        else if(title && !inFeed) {
            mainContentHtml = <p dangerouslySetInnerHTML={inFeed ? {__html: question.replace(/^\s*[\r\n]/gm, '')} : {__html: question}}></p>
        }
        else{
            mainContentHtml = <p className={cx(inFeed && (question.length > 300 || question.split(/\r\n|\r|\n/).length > 3) ? "content-text-crop" : "")} onClick={() => {gtmSend('dynamic', 'Question Card', 'click-question-click', match.path)}}>
                                <a className={cx('question-card-link')} href={`${contentHub? url : `/${viewUrl}`}`} {...relValue} dangerouslySetInnerHTML={inFeed ? {__html: question.replace(/^\s*[\r\n]/gm, '')} : {__html: question}}></a>
                              </p>
        }
    }

    return (
        <div className={cx("question-elements", "question-card")}>
            {titleHtml}

            <div className={cx("text-desc")}>
                { mainContentHtml }
                
                { inFeed && question && (question.length > 300 || question.split(/\r\n|\r|\n/).length > 3) && <a className={cx('read-more-link')} href={`${contentHub? url : `/${viewUrl}`}`}>{t('lp_read_more')}</a> }
            </div>

            {
                !!images.length &&
                <div className={cx("img-slide-wrap", (showNSFW ? "note-safe-blur" : ""))}>
                    {
                        showNSFW &&
                        <div className={cx('nsfw-screen')} onClick={nsfwHandler} >
                            <p>
                                <span>NSFW</span>
                                <span>{t('tap_to_view_photo')}</span>
                            </p>
                        </div>
                    }

                    <div className={cx("img-blur-wrap")}>
                        <div style={{backgroundImage:'url('+images[0].thumbnail+')'}}></div>
                        <ImageLightbox images={images} imageAltText={title} type={images[0].type} />
                    </div>
                </div>
            }

        </div>
    )
}

const QuestionCardComponent = CardTemplateComponent(QuestionCard);

export default translate()(QuestionCardComponent);
